module.exports = __webpack_public_path__ + "static/media/select-up.38cfe7f1.svg";